import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../../components/Navbar";
import { TextField, Button, CircularProgress, Box, Typography } from "@mui/material";
import { changePassword } from "../../api/apiService"; // Certifique-se de que esse método esteja implementado no authService.js

const ChangePassword = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  // Estado para armazenar os erros de cada campo em tempo real
  const [errors, setErrors] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  // Estado para erros gerais (ex: ao submeter o formulário)
  const [globalError, setGlobalError] = useState("");

  // Estado para o loading do botão
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Atualiza o formData e já valida em tempo real
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      let newErrors = { ...errors };

      if (name === "newPassword") {
        // Valida se a nova senha possui pelo menos 8 caracteres
        if (value.length < 8) {
          newErrors.newPassword = "A nova senha deve ter pelo menos 8 caracteres.";
        } else {
          newErrors.newPassword = "";
        }
        // Se houver valor em confirmPassword, valida se coincidem
        if (updatedData.confirmPassword && updatedData.confirmPassword !== value) {
          newErrors.confirmPassword = "Nova senha e confirmação não coincidem.";
        } else {
          newErrors.confirmPassword = "";
        }
      } else if (name === "confirmPassword") {
        // Valida se a confirmação coincide com a nova senha
        if (value !== updatedData.newPassword) {
          newErrors.confirmPassword = "Nova senha e confirmação não coincidem.";
        } else {
          newErrors.confirmPassword = "";
        }
      }

      setErrors(newErrors);
      return updatedData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGlobalError("");

    // Se houver erros em tempo real, impede o envio do formulário
    if (errors.newPassword || errors.confirmPassword) {
      setGlobalError("Por favor, corrija os erros acima antes de prosseguir.");
      return;
    }

    // Validação adicional caso o usuário tente submeter com nova senha com menos de 8 caracteres
    if (formData.newPassword.length < 8) {
      setGlobalError("A nova senha deve ter pelo menos 8 caracteres.");
      return;
    }

    // Validação para garantir que as senhas coincidam
    if (formData.newPassword !== formData.confirmPassword) {
      setGlobalError("Nova senha e confirmação não coincidem.");
      return;
    }

    setIsLoading(true);
    try {
      // Chama o endpoint de troca de senha
      await changePassword(formData);
      toast.success("Senha atualizada com sucesso!", {
        position: "bottom-center",
        autoClose: 2000,
      });
      // Redireciona após 2 segundos
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      setGlobalError(err.response?.data?.message || "Erro ao atualizar a senha. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="main-content">
      <Navbar />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 4,
        }}
      >
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            width: "100%",
            maxWidth: 500,
            p: 3,
            boxShadow: 3,
            borderRadius: 2,
          }}
        >
          <Typography variant="h4" gutterBottom>
            Trocar Senha
          </Typography>

          {globalError && (
            <Typography variant="body1" color="error" sx={{ mb: 2 }}>
              {globalError}
            </Typography>
          )}

          <TextField
            fullWidth
            label="Senha Atual"
            name="currentPassword"
            type="password"
            value={formData.currentPassword}
            onChange={handleChange}
            required
            margin="normal"
          />

          <TextField
            fullWidth
            label="Nova Senha"
            name="newPassword"
            type="password"
            value={formData.newPassword}
            onChange={handleChange}
            required
            margin="normal"
            error={Boolean(errors.newPassword)}
            helperText={errors.newPassword}
          />

          <TextField
            fullWidth
            label="Confirmar Nova Senha"
            name="confirmPassword"
            type="password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            margin="normal"
            error={Boolean(errors.confirmPassword)}
            helperText={errors.confirmPassword}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress size={24} style={{ color: "white" }} />
            ) : (
              "Atualizar Senha"
            )}
          </Button>

          <Button
            onClick={() => navigate(-1)}
            variant="outlined"
            color="secondary"
            fullWidth
            sx={{ mt: 2 }}
          >
            Voltar
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default ChangePassword;
